'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  API_URL: '"http://localhost:5000/"',
  RECAPTCHA_SITEKEY: '"6LefT8gZAAAAACo9CJEwIQ4XYIm-OfUIhm49zbaO"'
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 1